export const ROUTE_NAME_ORDER_LOGIN = 'login'
export const ROUTE_NAME_ORDER_MANAGEMENT = 'order_management'
export const ROUTE_NAME_ORDER_DELIVERY = 'delivery_order'
export const ROUTE_NAME_ORDER_COLLECTING = 'collecting_order'
export const ROUTE_NAME_TASKS_PRODUCT = 'product_order'
export const ROUTE_NAME_TASKS_ORDER = 'cooking_order'
export const ROUTE_NAME_COLD_COOKER = 'cold_cooker'
export const ROUTE_NAME_COLD_CUTTER = 'cold_cutter'
export const ROUTE_NAME_HOT_COOKER = 'hot_cooker'
export const ROUTE_NAME_PIZZA_DOUGH = 'pizza_dough'
export const ROUTE_NAME_PIZZA_COOKER = 'pizza_cooker'
export const ROUTE_NAME_PIZZA_COLLECTOR = 'pizza_collector'
export const ROUTE_NAME_DELIVERY_COURIER = 'delivery_courier'
export const ROUTE_NAME_LOGOUT = 'logout'
export const ROUTE_NAME_COURIER_STATS = 'courier_stats'
export const ROUTE_NAME_ADMIN_STATS = 'admin_stats'
export const ROUTE_NAME_ACCOUNTING_WORKERS = 'accounting_workers'
export const ROUTE_NAME_WORKSHOP_STATS = 'stats_workshop'



// WEBPACK FOOTER //
// ./src/constants/routes.js